document.documentElement.className = document.documentElement.className.replace(
  'no-js',
  'js',
)

import './main.css'

import Alpine from 'alpinejs'
import ui from '@alpinejs/ui'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import Cookies from 'js-cookie'

window.Cookies = Cookies

Alpine.plugin(ui)
Alpine.plugin(focus)
Alpine.plugin(collapse)

window.Alpine = Alpine

Alpine.start()
